import { render, staticRenderFns } from "./hospital.vue?vue&type=template&id=18a15862&scoped=true&"
import script from "./hospital.vue?vue&type=script&lang=js&"
export * from "./hospital.vue?vue&type=script&lang=js&"
import style0 from "./hospital.vue?vue&type=style&index=0&id=18a15862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a15862",
  null
  
)

export default component.exports